import React from 'react';
import { withStyles } from '@material-ui/core';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import Paper from '@material-ui/core/Paper';

const styles = theme => ({
    root: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(6)
    },
    panel: {
        maxWidth: 780,
        margin: '0 auto',
        padding: theme.spacing(4, 4.5),
        borderRadius: theme.spacing(3),
        background: theme.palette.type === 'dark'
            ? 'linear-gradient(145deg, rgba(29, 35, 48, 0.72), rgba(20, 24, 33, 0.68))'
            : 'linear-gradient(145deg, rgba(255, 255, 255, 0.72), rgba(244, 246, 253, 0.68))',
        backdropFilter: 'blur(14px) saturate(135%)',
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(3),
        }
    },
    heading: {
        marginBottom: theme.spacing(2)
    },
    paragraph: {
        marginBottom: theme.spacing(1.5)
    }
});

const Contact = ({ classes }) => {
    return (
        <div className={classes.root}>
            <Container>
                <Paper elevation={0} className={classes.panel}>
                    <Typography variant="h5" className={classes.heading}>
                        Contact NextGen PINN Hub
                    </Typography>
                    <Typography variant="body1" className={classes.paragraph}>
                        Use <Link href="mailto:nextgenaischool@gmail.com">nextgenaischool@gmail.com</Link> for current support, solver-sharing questions, or pilot discussions around PINN workflows.
                    </Typography>
                    <Typography variant="body1" className={classes.paragraph}>
                        The live app endpoint is <Link href="https://pinnhub.nextgenaischool.in/" target="_blank" rel="noreferrer">pinnhub.nextgenaischool.in</Link>.
                    </Typography>
                </Paper>
            </Container>
        </div>
    );
};

export default withStyles(styles)(Contact);
